import React from 'react';
import dynamic from 'next/dynamic';
import cx from 'clsx';
import { Anchor as AnchorType } from '../../../util/types';
import classes from './FooterColumn.module.scss';

const Text = dynamic(() => import('../../../common/Text/Text'));
const Anchor = dynamic(() => import('../../../common/Anchor/Anchor'));

export interface FooterColumnProps extends React.HTMLProps<HTMLDivElement> {
  title?: string,
  links?: {
    fields: AnchorType,
  }[],
}

export default function FooterColumn({
  className,
  title,
  links,
  ...others
}: FooterColumnProps) {

  return (
    <div className={cx(classes.links, className)} {...others}>
      <Text className={classes.title} bold>
        {title}
      </Text>
      {links?.map((link, index) => (
        <Anchor className={classes.footerLink} {...link.fields} key={index} />
      ))}
    </div>
  );
}

FooterColumn.displayName = '@ioa/lablocator/FooterColumn';
